"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Wave = void 0;

var _react = _interopRequireWildcard(require("react"));

var _range = _interopRequireDefault(require("lodash/range"));

var _styles = require("@material-ui/core/styles");

var _colorAlpha = _interopRequireDefault(require("color-alpha"));

var _useColors = _interopRequireDefault(require("../../hooks/use-colors"));

var _formatTime = require("../../utils/format-time");

var _useTimeCursorTime = require("../../hooks/use-time-cursor-time");

var _HighlightValueLabels = _interopRequireDefault(require("../HighlightValueLabels"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var userSelectOffStyle = {
  userSelect: "none",
  whiteSpace: "pre",
  fontVariantNumeric: "tabular-nums"
};

var reduceForVisibleDuration = function reduceForVisibleDuration(data, startTime, visibleDuration, width) {
  var firstInnerIndex = data.findIndex(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 1),
        t = _ref2[0];

    return t >= startTime;
  });
  var visibleSamples = data.slice(firstInnerIndex).findIndex(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 1),
        t = _ref4[0];

    return t >= startTime + visibleDuration;
  });
  visibleSamples = visibleSamples === -1 ? data.length - firstInnerIndex : visibleSamples;
  var lastInnerIndex = firstInnerIndex + visibleSamples;
  data = data.slice(Math.max(0, firstInnerIndex - 1), lastInnerIndex + 1);
  var minDistance = visibleDuration / (width / 4);
  var points = [data[0]];
  var lastAddedPointIndex = 0;

  for (var i = 1; i < data.length; i++) {
    if (data[i][0] - points[points.length - 1][0] > minDistance) {
      // points.push(data[i])
      var timeSinceLastPoint = data[i][0] - points[points.length - 1][0];

      if (i - lastAddedPointIndex === 1) {
        points.push(data[i]);
      } else {
        points.push([data[i][0] - timeSinceLastPoint / 2, Math.max.apply(Math, _toConsumableArray(data.slice(lastAddedPointIndex + 1, i + 1).map(function (_ref5) {
          var _ref6 = _slicedToArray(_ref5, 2),
              v = _ref6[1];

          return v;
        })))]);
        points.push([data[i][0], Math.min.apply(Math, _toConsumableArray(data.slice(lastAddedPointIndex + 1, i + 1).map(function (_ref7) {
          var _ref8 = _slicedToArray(_ref7, 2),
              v = _ref8[1];

          return v;
        })))]);
      }

      lastAddedPointIndex = i;
    }
  }

  return points;
};

var Wave = function Wave(_ref9) {
  var curves = _ref9.curves,
      width = _ref9.width,
      height = _ref9.height,
      transformMatrix = _ref9.transformMatrix,
      timeFormat = _ref9.timeFormat,
      _ref9$durationGroups = _ref9.durationGroups,
      durationGroups = _ref9$durationGroups === void 0 ? [] : _ref9$durationGroups,
      _ref9$timestamps = _ref9.timestamps,
      timestamps = _ref9$timestamps === void 0 ? [] : _ref9$timestamps,
      gridLineMetrics = _ref9.gridLineMetrics,
      timeCursorTime = _ref9.timeCursorTime,
      _ref9$showValues = _ref9.showValues,
      showValues = _ref9$showValues === void 0 ? false : _ref9$showValues;
  var colors = (0, _useColors.default)();
  var recoilTimeCursorTime = (0, _useTimeCursorTime.useTimeCursorTime)();
  timeCursorTime = timeCursorTime === undefined ? recoilTimeCursorTime : timeCursorTime;
  var visibleDuration = gridLineMetrics.visibleDuration,
      startTimeOnGraph = gridLineMetrics.startTimeOnGraph,
      majorDuration = gridLineMetrics.majorDuration,
      numberOfMajorGridLines = gridLineMetrics.numberOfMajorGridLines,
      numberOfMinorGridLines = gridLineMetrics.numberOfMinorGridLines,
      majorGridLinePixelOffset = gridLineMetrics.majorGridLinePixelOffset,
      minorGridLinePixelOffset = gridLineMetrics.minorGridLinePixelOffset,
      majorGridLinePixelDistance = gridLineMetrics.majorGridLinePixelDistance,
      minorGridLinePixelDistance = gridLineMetrics.minorGridLinePixelDistance;
  var timeCursorXPosition = timeCursorTime !== undefined ? transformMatrix.applyToPoint(timeCursorTime, 0).x : undefined;
  var visibleTransformedPointsOnCurves = (0, _react.useMemo)(function () {
    var visibleTransformedPointsOnCurves = [];

    var _iterator = _createForOfIteratorHelper(curves),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var curve = _step.value;
        visibleTransformedPointsOnCurves.push(reduceForVisibleDuration(curve.data, startTimeOnGraph, visibleDuration, width).map(function (_ref10) {
          var _ref11 = _slicedToArray(_ref10, 2),
              t = _ref11[0],
              y = _ref11[1];

          return _objectSpread(_objectSpread({}, transformMatrix.applyToPoint(t, y)), {}, {
            t: t,
            value: y
          });
        }));
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    return visibleTransformedPointsOnCurves;
  }, [transformMatrix, curves, startTimeOnGraph, visibleDuration, width]);
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: width,
    height: height
  }, (0, _range.default)(-5, numberOfMajorGridLines + 1).map(function (i) {
    var timeAtLine = Math.floor(startTimeOnGraph / majorDuration) * majorDuration + majorDuration * i;
    var lineX = majorGridLinePixelOffset + majorGridLinePixelDistance * i;
    var globalTimelineIndex = Math.floor(timeAtLine / majorDuration);
    var textElm = null;

    if (globalTimelineIndex % 1 === 0) {
      var timeLines = (0, _formatTime.formatTime)(timeAtLine, timeFormat, visibleDuration).split("\n");
      textElm = timeLines.map(function (tl, i) {
        return /*#__PURE__*/_react.default.createElement("text", {
          key: i,
          x: lineX + 5,
          y: 12 + i * 12,
          fill: colors.base0,
          fontSize: 12,
          pointerEvents: "none",
          style: userSelectOffStyle
        }, tl);
      });
    }

    return /*#__PURE__*/_react.default.createElement(_react.Fragment, {
      key: i
    }, i >= 0 && /*#__PURE__*/_react.default.createElement("line", {
      opacity: 0.5,
      stroke: colors.base01,
      x1: lineX,
      x2: lineX,
      y1: 0,
      y2: height
    }), textElm);
  }), numberOfMajorGridLines < 12 && (0, _range.default)(numberOfMinorGridLines).map(function (i) {
    var lineX = minorGridLinePixelOffset + minorGridLinePixelDistance * i;
    return /*#__PURE__*/_react.default.createElement("line", {
      key: i,
      opacity: 0.25,
      stroke: colors.base01,
      x1: lineX,
      x2: lineX,
      y1: 0,
      y2: height
    });
  }), durationGroups.flatMap(function (_ref12, dgi) {
    var durations = _ref12.durations,
        dgColor = _ref12.color;
    return durations.map(function (duration, di) {
      var _transformMatrix$appl = transformMatrix.applyToPoint(duration.start, 0),
          startX = _transformMatrix$appl.x;

      var _transformMatrix$appl2 = transformMatrix.applyToPoint(duration.end, 0),
          endX = _transformMatrix$appl2.x;

      if (isNaN(startX) || isNaN(endX)) return null;
      return /*#__PURE__*/_react.default.createElement("rect", {
        key: "".concat(dgi, ",").concat(di),
        fill: (0, _colorAlpha.default)(duration.color || dgColor, 0.2),
        x: startX,
        y: 0,
        width: endX - startX,
        height: height
      });
    });
  }), curves.map(function (curve, i) {
    return /*#__PURE__*/_react.default.createElement("polyline", {
      key: i,
      stroke: curve.color,
      fill: "transparent",
      points: visibleTransformedPointsOnCurves[i].map(function (p) {
        return "".concat(p.x, ",").concat(p.y);
      }).join(" ")
    });
  }), timestamps.map(function (ts, i) {
    var _transformMatrix$appl3 = transformMatrix.applyToPoint(ts.time, 0),
        x = _transformMatrix$appl3.x;

    return /*#__PURE__*/_react.default.createElement("line", {
      key: i,
      x1: x,
      x2: x,
      y1: 0,
      y2: height,
      stroke: ts.color,
      strokeWidth: 1
    });
  }), timeCursorTime !== undefined && /*#__PURE__*/_react.default.createElement("line", {
    x1: timeCursorXPosition,
    x2: timeCursorXPosition,
    y1: 0,
    y2: height,
    stroke: colors.green,
    strokeWidth: 1
  }), showValues && /*#__PURE__*/_react.default.createElement(_HighlightValueLabels.default, {
    visibleTransformedPointsOnCurves: visibleTransformedPointsOnCurves,
    curveColors: curves.map(function (c) {
      return c.color;
    })
  }));
};

exports.Wave = Wave;
var _default = Wave;
exports.default = _default;